import React from 'react';
import '../../../assets/styles/components/IconBadge.css';
import '../../../assets/styles/components/SectionCard.css';

const SectionCard = ({ icon, title, subtitle, heading, actions, testId, children }) => {
  const hasHead = Boolean(icon || title || heading || actions);

  return (
    <section className={`section-card${hasHead ? '' : ' section-card--untitled'}`} data-testid={testId}>
      {hasHead && (
        <div className="section-card-head">
          {icon && <span className="te-icon-badge">{icon}</span>}
          {heading || (
            <div className="section-card-titles">
              <span className="section-card-title">{title}</span>
              {subtitle && <span className="section-card-subtitle">{subtitle}</span>}
            </div>
          )}
          {actions && <div className="section-card-actions">{actions}</div>}
        </div>
      )}
      <div className="section-card-body">{children}</div>
    </section>
  );
};

export default SectionCard;
